<section class="header">
  <div class="left">
    <div class="title">Add Deal</div>
  </div>
  <div class="right">
    <button class="close-button" mat-icon-button (click)="discard()" [tabIndex]="-1">
      <mat-icon [svgIcon]="'close'"></mat-icon>
    </button>
  </div>
</section>

<section class="flex flex-auto">
  <!-- PDF Viewer -->
  <div class="flex flex-col w-7/12 border-right">
    <div class="viewer-wrapper">
      <div class="viewer-resize">
        <div #viewer class="viewer"></div>
      </div>
    </div>
  </div>

  <!-- Add Deal Form -->
  <div class="flex flex-col w-5/12 side-panel">
    <app-custom-form
      [allowedFields]="customFormConfig.allowedFields"
      [commonData]="customFormConfig.commonData"
      [dataSources]="customFormConfig.dataSources"
      [relatedToType]="customFormConfig.relatedToType"
      [renderAttachFileField]="customFormConfig.renderAttachFileField"
      [selectedFields]="customFormConfig.selectedFields"
      [showFormTitle]="customFormConfig.showFormTitle"
      [showCancelButtons]="customFormConfig.showCancelButtons"
      [saveAction]="customFormConfig.saveAction"
      [beforeSaveAction]="customFormConfig.beforeSaveAction"
      (onTemplateChanged)="customFormConfig.onTemplateChanged($event)"
      [enableAiButton]="true"
    ></app-custom-form>
  </div>
</section>
